export const SET_HEADER_BUTTONS_TYPE = 'SET_HEADER_BUTTONS';
export const SET_HEADER_SCORES_GROUP_TYPE = 'SET_HEADER_SCORES_GROUP';
export const SET_AUTO_SELECT_NEXT_WELL_TYPE = 'SET_AUTO_SELECT_NEXT-WELL';
export const SET_HIDE_AUTO_SCORES_TYPE = 'SET_HIDE_AUTO_SCORES';

export function setHeaderButtons(btns) {
  return {
    type: SET_HEADER_BUTTONS_TYPE,
    buttons: btns,
  };
}

export function setHeaderScoreGroup(scoreGroup) {
  return {
    type: SET_HEADER_SCORES_GROUP_TYPE,
    scoreGroup,
  };
}

export function setAutoSelectNextWell(nextWell) {
  return {
    type: SET_AUTO_SELECT_NEXT_WELL_TYPE,
    nextWell,
  };
}
export function setHideAutoScores(hideAutoScores) {
  return {
    type: SET_HIDE_AUTO_SCORES_TYPE,
    hideAutoScores,
  };
}
